import { useEffect, useState } from "react";
import { FREE_ALERTS_BANNER, LOGIN_ROUTE, SETUP_ACCOUNT_STEP_ONE_ROUTE } from "../../routes";
import { auth, isAuthenticated } from "../../services/firebase";
import dataProvider from "../../services/dataProvider";
import axios from "axios";
import authServices from "../../services/authServices";
import DashboardNavbar from "./common/dashboard-navbar/dashboard-navbar";
import DashboardSidebar from "./common/dashboard-sidebar/dashboard-sidebar";
import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import {
    ACTIVITY_LOGS_ROUTE,
    ADD_MEMBERS_ROUTE,
    DOWNLOADABLE_FORMS_ROUTE,
    EDIT_MEMBERS_ROUTE,
    FORMS_LIST_ROUTE,
    FORMS_ROUTE,
    FREE_ALERT_SUBSCRIBER_LIST_ROUTE,
    FRONT_DESK_FORM,
    FRONT_DESK_FORM_LIST_ROUTE,
    FRONT_DESK_SUBMITTED_FORMS_ROUTE,
    MEMBER_OVERVIEW_ROUTE,
    MEMBER_PROFILE_ROUTE,
    SEARCH_QUERY_TOOL_DETAILS_ROUTE,
    SEARCH_QUERY_TOOL_RESULT_ROUTE,
    SEARCH_QUERY_TOOL_ROUTE,
    SUBMITTED_FORMS_ROUTE,
    SUBSCRIBER_LIST_ROUTE,
    TASKS_ROUTE,
} from "./dashboard-routes";
import SearchQueryTool from "./pages/search-query-tool/search-query-tool";
import AddMembers from "./pages/members/add-members";
import MemberProfile from "./pages/members/member-profile";
import EditMembers from "./pages/members/edit-members";
import MemberOverview from "./pages/members/member-overview";
import DetailsPage from "./pages/search-query-tool/details-page";
import Tasks from "./pages/tasks/tasks";
import FormsList from "./pages/forms/forms-list";
import Forms from "./pages/forms/forms";

import "./dashboard.scss";
import SubmittedForms from "./pages/forms/submitted-forms";
import ForntDeskFormList from "./pages/front-desk/front-desk-form-list";
import FrontDeskSubmittedForms from "./pages/front-desk/front-desk-submitted-forms";
import ActivityLog from "./pages/activity-log/activity-log";
import FrontDeskForm from "./pages/front-desk/front-desk-form";
import DownloadableForms from "./pages/forms/downloadable-forms";
import DashboardOverview from "./pages/dashboard/dashboard-overview";
import SearchQueryToolResultPage from "./pages/search-query-tool/search-result-page";
import FreeAlertSubscriberList from "./pages/free-alert-subscriber-list/free-alert-subscriber-list";
import SubscriberList from "./pages/subscriber-list/subscriber-list";

const Dashboard = ({ history }) => {
    let { path, url } = useRouteMatch();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [aXNzdXBlcmFkbWlu, setaXNzdXBlcmFkbWlu] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [currentOrg, setCurrentOrg] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [userName, setUserName] = useState("");

    const userHasFilledData = async () => {
        let res = await axios.get(dataProvider.baseUrl + "checkIfStep2DetailsExists", {
            headers: {
                token: authServices.getToken(),
            },
        });
        //console.log(res);
        return res;
    };

    function setOrg(id) {
        authServices.setOrgId(id);
        setCurrentOrg(id);
    }

    useEffect(async () => {
        setIsLoading(true);
        if (isAuthenticated()) {
            if (authServices.getaXNzdXBlcmFkbWlu() === "true") {
                //console.log("IS SUPER ADMIN");
                // check if user is admin
                var config = {
                    method: "post",
                    url: dataProvider.baseUrl + "getAllOrganisationsData",
                    headers: {
                        token: authServices.getToken(),
                    },
                };

                axios(config)
                    .then(function (response) {
                        setIsLoading(false);
                        if (response.data.status === "success") {
                            setOrgList(response.data.data);
                            if (authServices.getOrgId()) {
                                setCurrentOrg(authServices.getOrgId());
                            } else {
                                setCurrentOrg(response.data.data[0].id);
                                authServices.setOrgId(response.data.data[0].id);
                            }
                        }
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        console.error(error);
                    });

                setaXNzdXBlcmFkbWlu(true);
                return;
            }

            let res = await userHasFilledData();
            setUserName(res?.data?.userData?.fullName || "") ;
            if (res.data.NominatedInchargeDetailsExists === false) {
                if (res.data.LicenceInchargeDetailsExists === false) {
                    setIsLoading(false);
                    history.replace(SETUP_ACCOUNT_STEP_ONE_ROUTE);
                } else {
                    authServices.setOrgId(res.data.userData.organisationId);

                    if (res.data.userData.signedInTillNow === false || res.data.userData.signedInTillNow === "false") {
                        axios
                            .get(dataProvider.baseUrl + "userSignedIn", {
                                headers: {
                                    token: authServices.getToken(),
                                },
                            })
                            .then((res2) => {
                                //console.log("Sent User Signed In", res2);
                                setIsLoading(false);
                                history.replace({
                                    pathname: FREE_ALERTS_BANNER,
                                    state: {
                                        email: res.data.userData.email,
                                        name: res.data.userData.fullName,
                                        phone_number: res.data.userData.mobileNumber,
                                        license_number: res.data.userData.licenseNumber,
                                    },
                                });
                            })
                            .catch((error) => {
                                setIsLoading(false);
                                console.error(error);
                            });
                    } else {
                        setIsLoading(false);
                    }
                }
            } else {
                // setIsLoading(false);
                authServices.setOrgId(res.data.userData.organisationId);

                if (res.data.userData.signedInTillNow === false || res.data.userData.signedInTillNow === "false") {
                    axios
                        .get(dataProvider.baseUrl + "userSignedIn", {
                            headers: {
                                token: authServices.getToken(),
                            },
                        })
                        .then((res2) => {
                            // console.log("Sent User Signed In", res2);
                            // setIsLoading(false);
                            history.replace({
                                pathname: FREE_ALERTS_BANNER,
                                state: {
                                    email: res.data.userData.email,
                                    name: res.data.userData.fullName,
                                    phone_number: res.data.userData.mobileNumber,
                                    license_number: res.data.userData.licenseNumber,
                                },
                            });
                        })
                        .catch((error) => {
                            setIsLoading(false);
                            console.error(error);
                        });
                } else {
                    setIsLoading(false);
                }
            }
        } else {
            setIsLoading(false);
            history.replace(LOGIN_ROUTE);
        }
    }, []);

    function toggleSidebar(state = "EMPTY") {
        if (state != "EMPTY") {
            setSidebarOpen(state);
        } else {
            setSidebarOpen((s) => {
                return !s;
            });
        }
    }

    return (
        <div id="dashboard" className="w-100 vh-100">
            <div className="" id="dashboard-window" style={{ minHeight: "100vh" }}>
                <div className="position-fixed position-lg-relative" id="sidebar" data-state={sidebarOpen ? "open" : "close"}>
                    <DashboardSidebar isOpen={sidebarOpen} url={url} toggle={toggleSidebar} />
                </div>
                
                <div
                    className="flex-fill d-flex flex-column vh-100 position-relative"
                    style={{ backgroundColor: "hsla(209, 19%, 95%, 1)" }}
                    id="content"
                >
                    <DashboardNavbar
                        aXNzdXBlcmFkbWlu={aXNzdXBlcmFkbWlu}
                        orgList={orgList}
                        currentOrg={currentOrg}
                        setCurrentOrg={setOrg}
                        history={history}
                        toggleHandler={toggleSidebar}
                        userName={userName}
                    />

                    {isLoading ? (
                        <div className="d-flex align-items-center justify-content-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <main id="dashboard-main" className="position-relative flex-fill" style={{ overflowY: "auto" }}>
                            <Switch>
                                <Route exact path={path} component={DashboardOverview} />
                                <Route exact path={path + SEARCH_QUERY_TOOL_ROUTE} url={url} component={SearchQueryTool} />
                                <Route
                                    path={path + SEARCH_QUERY_TOOL_RESULT_ROUTE}
                                    url={url}
                                    component={SearchQueryToolResultPage}
                                />
                                <Route exact path={path + MEMBER_OVERVIEW_ROUTE} component={MemberOverview} />
                                <Route exact path={path + ADD_MEMBERS_ROUTE} component={AddMembers} />
                                <Route exact path={path + MEMBER_PROFILE_ROUTE} component={MemberProfile} />
                                <Route exact path={path + EDIT_MEMBERS_ROUTE} component={EditMembers} />
                                <Route exact path={path + SEARCH_QUERY_TOOL_DETAILS_ROUTE} component={DetailsPage} />
                                <Route exact path={path + TASKS_ROUTE} component={Tasks} />
                                <Route exact path={path + FORMS_LIST_ROUTE} component={FormsList} />
                                <Route path={path + FORMS_ROUTE} component={Forms} />
                                <Route exact path={path + SUBMITTED_FORMS_ROUTE} component={SubmittedForms} />
                                <Route exact path={path + FRONT_DESK_FORM_LIST_ROUTE} component={ForntDeskFormList} />
                                <Route
                                    exact
                                    path={path + FRONT_DESK_SUBMITTED_FORMS_ROUTE}
                                    component={FrontDeskSubmittedForms}
                                />
                                <Route exact path={path + ACTIVITY_LOGS_ROUTE} component={ActivityLog} />
                                <Route exact path={path + SUBSCRIBER_LIST_ROUTE} component={SubscriberList} />
                                <Route exact path={path + FREE_ALERT_SUBSCRIBER_LIST_ROUTE} component={FreeAlertSubscriberList} />
                                <Route exact path={path + FRONT_DESK_FORM} component={FrontDeskForm} />
                                <Route exact path={path + DOWNLOADABLE_FORMS_ROUTE} component={DownloadableForms} />
                                <Redirect from="*" to={path} />
                            </Switch>
                        </main>
                    )}
                </div>
                <div className="backdrop" data-state={sidebarOpen?"show":"hide"} onClick={()=>{setSidebarOpen(false)}} ></div>
            </div>
        </div>
    );
};

export default Dashboard;
